
import React from "react"

const IconGenerator = React.memo(function InfoCoIconGeneratormponent({iconTitle,IconSvg,uiChangeFunc}) {

    const uiChangeFuncCall = () => {

        uiChangeFunc(iconTitle)
    }

  
    return(

        <>
            <a href="#" className="func_ui_comp_div" onClick={uiChangeFuncCall}>
            <IconSvg />
            <span>{iconTitle}</span>
            </a>
        </>

    )
});




export default IconGenerator